class EventStream {
  static CONNECTING = 0;
  static OPEN = 1;
  static CLOSED = 2;

  constructor(response) {
    this.listeners = {};
    this.readyState = EventStream.CONNECTING;
    this._lastEventId = null;
    this.reconnectionTime = 3000;

    if (response instanceof Response) {
      this.reader = response.body.getReader();
      this.decoder = new TextDecoder('utf-8');
    } else {
      // 如果不是 Response 则立即标记为关闭
      this.readyState = EventStream.CLOSED;
    }
  }

  get lastEventId() {
    return this._lastEventId;
  }

  async analysis() {
    this.readyState = EventStream.OPEN;
    this.dispatchEvent('open', { type: 'open' });

    let buffer = '';
    let currentEventType = 'message';
    let dataBuffer = [];
    let lastEventId = null;

    const processLine = (line) => {
      if (line === '') {
        // 空行 -> 分派事件
        if (dataBuffer.length === 0) return;

        // 直接 join，不要移除末尾 \n
        const data = dataBuffer.join('\n');

        // 更新并过滤 null 字符
        this._lastEventId = lastEventId;
        const safeId = lastEventId ? lastEventId.replace(/\0/g, '') : lastEventId;
        const eventName = currentEventType || 'message';

        const event = {
          data,
          lastEventId: safeId,
          origin: '',
          type: eventName,
          target: this,
          source: this,
        };

        if (this.listeners[eventName]) {
          this.listeners[eventName].forEach(cb => {
            try {
              cb.call(this, event);
            } catch (e) { /* ignore */ }
          });
        }

        // 重置 data 缓冲区，但事件类型依然保持
        dataBuffer = [];
      } else if (line.startsWith(':')) {
        // 注释行，忽略
      } else {
        const colonIndex = line.indexOf(':');
        let field, value;
        if (colonIndex === -1) {
          field = line;
          value = '';
        } else {
          field = line.substring(0, colonIndex);
          value = line.substring(colonIndex + 1);
          if (value.startsWith(' ')) {
            value = value.substring(1);
          }
        }

        switch (field) {
          case 'event':
            currentEventType = value;
            break;
          case 'data':
            dataBuffer.push(value);
            break;
          case 'id':
            // 过滤 null 字符
            lastEventId = value.replace(/\0/g, '');
            break;
          case 'retry':
            this.reconnectionTime = parseInt(value, 10)
            break;
        }
      }
    };

    try {
      while (true) {
        const { done, value } = await this.reader.read();
        if (done) break;

        buffer += this.decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop();

        for (const line of lines) {
          processLine(line.endsWith('\r') ? line.slice(0, -1) : line);
        }
      }
    } catch (error) {
      // 读取/解码错误
    } finally {
      this.readyState = EventStream.CLOSED;
      this.dispatchEvent('finish', { type: 'finish', message: 'Connection closed!' });

      try {
        this.reader.releaseLock();
      } catch (e) { /* ignore */ }
    }
  }

  addEventListener(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  removeEventListener(event, callback) {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
  }

  dispatchEvent(event, data) {
    if (!this.listeners[event]) return;
    this.listeners[event].forEach(callback => {
      try {
        callback.call(this, data);
      } catch (e) {
        console.warn('Error in event listener for', event, e);
      }
    });
  }
}

export default EventStream;